import { render, staticRenderFns } from "./TemplateSavePop.vue?vue&type=template&id=d2d57188"
import script from "./TemplateSavePop.vue?vue&type=script&lang=js"
export * from "./TemplateSavePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2d57188')) {
      api.createRecord('d2d57188', component.options)
    } else {
      api.reload('d2d57188', component.options)
    }
    module.hot.accept("./TemplateSavePop.vue?vue&type=template&id=d2d57188", function () {
      api.rerender('d2d57188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/TemplateSavePop.vue"
export default component.exports